import { MessagesRepository } from '../messagesRepository';
import { container } from 'tsyringe';
import { useHistory } from 'react-router-dom';
import { useBehaviorSubject } from '../../../utils/helpers';
import { MessagesService } from '@base/features/chat/messagesService';
import React, { FormEvent, useState } from 'react';
import { MAIN_ROUTES } from '../../routing/constants/mainRoutes';
import { Message } from '../message';
import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';
import InviteService from '@base/features/game/model/inviteService';
import { IUserService } from '@base/features/user/model/interfaces';

type UseMainChat = {
  myMessage: string;
  handleMessage: (e: React.ChangeEvent<HTMLInputElement>) => void;
  messages: Message[];
  handleEmoji: (emoji: string) => void;
  sendMessage: (event: FormEvent<HTMLFormElement>) => void;
  joinTable: (tid: number) => void;
  joinPrivatChat(playerId?: number): void;
};

export const useMainChat = (): UseMainChat => {
  const messagesService: MessagesService = container.resolve('messagesService');
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const messagesRepository: MessagesRepository = container.resolve('messagesRepository');
  const inviteService: InviteService = container.resolve('inviteService');
  const userService: IUserService = container.resolve('userService');

  const history = useHistory();
  const messages = useBehaviorSubject(messagesRepository.onMessagesLobby);
  const [myMessage, setMyMessage] = useState('');

  function handleMessage(e: React.ChangeEvent<HTMLInputElement>): void {
    setMyMessage(e.target.value);
  }

  function handleEmoji(emoji: string) {
    setMyMessage((prevState) => `${prevState} ${emoji} `);
  }

  function sendMessage(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!myMessage.length) return;
    if (userService.isGuestPlayer())
      return userService.openGuestModal(() => history.push(MAIN_ROUTES.register));
    messagesService.sendMessage(myMessage);
    setMyMessage('');
  }

  function joinTable(tid: number): void {
    if (inviteService.acceptInvite(tid, false)) {
      history.push(MAIN_ROUTES.game);
    }
  }

  function joinPrivatChat(playerId?: number): void {
    if (!playerId || playerId === playersOnlineRepository.me?.getPid()) return;
    const player = playersOnlineRepository.getPlayerOnline(playerId);
    player && messagesService.joinPrivatChat(player);
  }

  return {
    myMessage,
    handleMessage,
    messages,
    handleEmoji,
    sendMessage,
    joinTable,
    joinPrivatChat,
  };
};
